import { ontPage } from 'pages/loans/[coin]/assets/page-data/coins/ont'
import { xdcPage } from 'pages/loans/[coin]/assets/page-data/coins/xdc'

import { kasPage } from 'pages/loans/[coin]/assets/page-data/coins/kas'

import { ICoinPageData } from './types'
import { ethPage } from './coins/eth'
import { bchPage } from './coins/bch'
import { btcPage } from './coins/btc'
import { dgbPage } from './coins/dgb'
import { dogePage } from './coins/doge'
import { firoPage } from './coins/firo'
import { xnoPage } from './coins/nano'
import { rvnPage } from './coins/rvn'
import { shibPage } from './coins/shib'
import { usdcPage } from './coins/usdc'
import { usdtPage } from './coins/usdt'
import { usdttrc20Page } from './coins/usdttrc20'
import { xmrPage } from './coins/xmr'
import { xrpPage } from './coins/xrp'
import { zilPage } from './coins/zil'
import { adaPage } from './coins/ada'
import { lrcPage } from './coins/lrc'
import { uniPage } from './coins/uni'
import { linkPage } from './coins/link'
import { vetPage } from './coins/vet'
import { sushiPage } from './coins/sushi'
import { ilvPage } from './coins/ilv'
import { zrxPage } from './coins/zrx'
import { solPage } from './coins/sol'
import { dashPage } from './coins/dash'
import { manaPage } from './coins/mana'
import { trxPage } from './coins/trx'
import { apePage } from './coins/ape'
import { hotPage } from './coins/hot'
import { aavePage } from './coins/aave'
import { ftmPage } from './coins/ftm'
import { bnbPage } from './coins/bnb'
import { dotPage } from './coins/dot'
import { ltcPage } from './coins/ltc'
import { mkrPage } from './coins/mkr'
import { maticPage } from './coins/matic'
import { zecPage } from './coins/zec'
import { algoPage } from './coins/algo'
import { flokiPage } from './coins/floki'
import { jasmyPage } from './coins/jasmy'
import { voltPage } from './coins/volt'
import { bonePage } from './coins/bone'
import { kishuPage } from './coins/kishu'
import { brisePage } from './coins/brise'
import { babyDogePage } from './coins/babydoge'
import { quackPage } from './coins/quack'
import { racaPage } from './coins/raca'
import { fluxPage } from './coins/flux'
import { vraPage } from './coins/vra'
import { reefPage } from './coins/reef'
import { pitPage } from './coins/pit'
import { atomPage } from './coins/atom'
import { hbarPage } from './coins/hbar'
import { okbPage } from './coins/okb'
import { imxPage } from './coins/imx'
import { ampPage } from './coins/amp'
import { flrPage } from './coins/flr'
import { qntPage } from './coins/qnt'
import { idPage } from './coins/id'
import { injPage } from './coins/inj'
import { runePage } from './coins/rune'

import { xautPage } from './coins/xaut'
import { compPage } from './coins/comp'

export const coinPageData: {
  [ticker: string]: ICoinPageData
} = {
  btc: btcPage,
  xaut: xautPage,
  comp: compPage,
  xmr: xmrPage,
  rvn: rvnPage,
  shib: shibPage,
  eth: ethPage,
  xno: xnoPage,
  bch: bchPage,
  usdt: usdtPage,
  usdttrc20: usdttrc20Page,
  usdc: usdcPage,
  dgb: dgbPage,
  firo: firoPage,
  doge: dogePage,
  xrp: xrpPage,
  zil: zilPage,
  ada: adaPage,
  lrc: lrcPage,
  uni: uniPage,
  link: linkPage,
  vet: vetPage,
  sushi: sushiPage,
  ilv: ilvPage,
  zrx: zrxPage,
  sol: solPage,
  dash: dashPage,
  mana: manaPage,
  trx: trxPage,
  ape: apePage,
  hot: hotPage,
  aave: aavePage,
  ftm: ftmPage,
  bnb: bnbPage,
  dot: dotPage,
  ltc: ltcPage,
  mkr: mkrPage,
  matic: maticPage,
  zec: zecPage,
  algo: algoPage,
  floki: flokiPage,
  flokibsc: flokiPage,
  jasmy: jasmyPage,
  volt: voltPage,
  bone: bonePage,
  kishu: kishuPage,
  brise: brisePage,
  babydoge: babyDogePage,
  quack: quackPage,
  raca: racaPage,
  flux: fluxPage,
  vra: vraPage,
  reef: reefPage,
  pit: pitPage,
  atom: atomPage,
  hbar: hbarPage,
  okb: okbPage,
  imx: imxPage,
  amp: ampPage,
  flr: flrPage,
  qnt: qntPage,
  id: idPage,
  inj: injPage,
  rune: runePage,
  ont: ontPage,
  xdc: xdcPage,
  kas: kasPage,
}
